import _get from 'lodash/get';
import dayjs from 'dayjs';

export const assembleString = (
    keys: string[],
    obj: any,
    divider: string = '-'
) => {
    let label = '';

    for (let i = 0; i < keys.length; i++) {
        let item = _get(obj, keys[i]);

        if (item) {
            label += item;

            if (i < keys.length - 1) {
                label += divider;
            }
        }
    }

    return label;
};

export const strToDate = (value: string, separator = ' ') => {
    let dateString = value
        ?.split(separator)?.[0]
        .split('.')
        .reverse()
        .join('-');
    let timeString = value?.split(separator)?.[1];

    return new Date(`${dateString} ${timeString ?? ''}`);
};

export const storeObject = (key: string, data: any) =>
    localStorage.setItem(key, data);

export const removeObject = (key: string) => localStorage.removeItem(key);

export const buildKey = (fieldName: string, num: number) =>
    `${fieldName}-${num}`;

export const splitStr = (str: string, splitter: string) => str?.split(splitter);

export const formatDate = (dateStr: string) => dayjs(dateStr);

export const truncateFullName = (fullName: string): string => {
    const parts = fullName.trim().split(/\s+/).filter(Boolean);

    if (parts.length === 0) return '';

    const lastName = parts[0];

    const initials = parts
        .slice(1)
        .map(p => p.charAt(0).toUpperCase() + '.')
        .join('');

    return initials ? `${lastName} ${initials}` : lastName;
};
